import type { ReactNode } from 'react';

import { resolveTimeFormat } from '@repo/ui/date-time';
import {
  DateTimeFormatProvider,
  useDateTimeFormat,
  type TimeFormatValue,
} from '@repo/ui/date-time-context';

import { useGetSettingsQuery } from '@/features/settings/api';

export { resolveTimeFormat };

export function TimeFormatProvider({ children }: { children: ReactNode }) {
  const { data } = useGetSettingsQuery();

  const timeFormat: TimeFormatValue =
    (data?.system?.timeFormat as TimeFormatValue) || '24h';

  return (
    <DateTimeFormatProvider timeFormat={timeFormat}>
      {children}
    </DateTimeFormatProvider>
  );
}

export function useTimeFormat() {
  const { timeFormat } = useDateTimeFormat();
  return { timeFormat };
}
